export const menuItems = [
  {
    id: 25,
    label: "Dashboard",
    link: "/",
    parentId: 1,
  },

  {
    id: 1,
    label: "Master Asesmen",
    subItems: [
      {
        id: 2,
        label: "Jabatan Asesmen (KKJ)",
        link: "/master-asesmen/jabatan-kompetensi",
        parentId: 1,
      },
      {
        id: 3,
        label: "Kategori Studi Kasus",
        link: "/master-asesmen/kategori-studi-kasus",
        parentId: 1,
      },
      {
        id: 4,
        label: "Tools Asesmen",
        link: "/master-asesmen/tools-asesmen",
        parentId: 1,
      },
      {
        id: 30,
        label: "Penyusun Soal",
        link: "/master-asesmen/penyusun-soal",
        parentId: 1,
      },
      {
        id: 5,
        label: "Konfigurasi Timer",
        link: "/master/timer",
        parentId: 1,
      },
      {
        id: 6,
        label: "Treshold Nilai",
        link: "/master/treshold-nilai",
        parentId: 1,
      },
      {
        id: 23,
        label: "Treshold Analisa Soal",
        link: "/master/treshold-analisa-soal",
        parentId: 1,
      },
      {
        id: 18,
        label: "Pelaksanaan",
        link: "/master/pelaksanaan",
        parentId: 1,
      },
      {
        id: 22,
        label: "Kategori Klasifikasi",
        link: "/master/kategori-klasifikasi",
        parentId: 1,
      },

      {
        id: 55,
        label: "Proctor Config",
        link: "/master/proctor-config",
        parentId: 1,
      },
      {
        id: 56,
        label: "Jenjang Jabatan",
        link: "/master-asesmen/jenjang-jabatan",
        parentId: 1,
      },
      {
        id: 57,
        label: "Target PeG",
        link: "/master-asesmen/target-peg",
        parentId: 1,
      },
      {
        id: 58,
        label: "Target UK",
        link: "/master-asesmen/target-uk",
        parentId: 1,
      },
      {
        id: 57,
        label: "Area",
        link: "/master/area",
        parentId: 1,
      },
      {
        id: 58,
        label: "Unit",
        link: "/master/unit",
        parentId: 1,
      },
    ],
  },
  {
    id: 40,
    label: "Master Survei",
    subItems: [
      {
        id: 41,
        label: "Master Pertanyaan Survei",
        link: "/master/pertanyaan",
        parentId: 40,
      },
      {
        id: 42,
        label: "Master Jawaban Survei",
        link: "/master/jawaban",
        parentId: 40,
      },
      {
        id: 44,
        label: "Master Kategori Survei",
        link: "/master/kategori-survei",
        parentId: 40,
      },
      {
        id: 45,
        label: "Master Dimensi Survei",
        link: "/master/dimensi-survei",
        parentId: 40,
      },
    ],
  },
  {
    id: 46,
    label: "Master Pegawai",
    subItems: [
      {
        id: 47,
        label: "Pegawai Internal",
        link: "/master/pegawai-internal",
        parentId: 46,
      },
      {
        id: 48,
        label: "Pegawai Eksternal",
        link: "/master/pegawai-eksternal",
        parentId: 46,
      },
      {
        id: 58,
        label: "Pegawai Atasan",
        link: "/master/pegawai-atasan",
        parentId: 46,
      },
      {
        id: 62,
        label: "Setting User HCBP",
        link: "/setting-hcbp",
        parentId: 46,
      },
    ],
  },
  {
    id: 49,
    label: "Master Verifikasi",
    subItems: [
      {
        id: 50,
        label: "Asesmen Objektif",
        link: "/master-verifikasi/asesmen-objektif",
        parentId: 49,
      },
      {
        id: 51,
        label: "Taksonomi Bloom",
        link: "/master-verifikasi/taksonomi",
        parentId: 49,
      },
      {
        id: 52,
        label: "Judul Diklat",
        link: "/master-verifikasi/diklat",
        parentId: 49,
      },
      {
        id: 53,
        label: "Tindakan Soal",
        link: "/master-verifikasi/tindakan-soal",
        parentId: 49,
      },
      {
        id: 54,
        label: "Referensi",
        link: "/master-verifikasi/referensi",
        parentId: 49,
      },
      {
        id: 55,
        label: "Validator",
        link: "/master-verifikasi/validator",
        parentId: 49,
      },
      {
        id: 56,
        label: "Level Kompetensi",
        link: "/master-verifikasi/level-kompetensi",
        parentId: 49,
      },
      {
        id: 57,
        label: "Kompetensi",
        link: "/master-verifikasi/kompetensi",
        parentId: 49,
      },
      {
        id: 58,
        label: "Kompetensi Validator",
        link: "/verifikasi/kompetensi-validator",
        parentId: 49,
      },
      {
        id: 59,
        label: "Kompetensi Level",
        link: "/master-verifikasi/kompetensi-level",
        parentId: 49,
      },
      {
        id: 60,
        label: "Penyusun Soal",
        link: "/master-asesmen/penyusun-soal",
        parentId: 49,
      },
      {
        id: 60,
        label: "Penyusun Soal",
        link: "/master-asesmen/penyusun-soal",
        noCheck: true,
        parentId: 49,
      },
    ],
  },
  {
    id: 65,
    label: "Review Soal",
    subItems: [
      {
        id: 66,
        label: "Review Soal Verifikasi",
        link: "/review-soal",
        parentId: 65,
      },
      {
        id: 69,
        label: "Review Soal Tools Asesmen",
        link: "/review-soal/tools-asesmen",
        parentId: 65,
      },
    ],
  },
  {
    id: 67,
    label: "Monitoring Review",
    subItems: [
      {
        id: 68,
        label: "Monitoring Review Soal Verifikasi",
        link: "/review-monitoring",
        parentId: 67,
      },
      {
        id: 70,
        label: "Monitoring Review Soal Tools Asesmen",
        link: "/monitoring-review/tools-asesmen",
        parentId: 67,
      },
    ],
  },
  {
    id: 24,
    label: "Master Kompetensi",
    link: "/master/kompetensi",
    parentId: 1,
  },
  {
    id: 10,
    label: "Jadwal Pelaksanaan",
    link: "/master-penjadwalan/jadwal-pelaksanaan",
    parentId: 1,
  },
  {
    id: 10,
    label: "Approver Atasan",
    link: "/approver-atasan",
    parentId: 1,
  },
  {
    id: 10,
    label: "Approver HCBP",
    link: "/approver-hcbp",
    parentId: 1,
  },
  {
    id: 10,
    label: "Work Order",
    link: "/work-order",
    parentId: 1,
  },
  {
    id: 15,
    label: "Report Asesmen",
    subItems: [
      {
        id: 16,
        label: "Report Jadwal",
        link: "/report-jadwal",
        parentId: 1,
      },
      {
        id: 11,
        label: "Report Nilai Kompetensi",
        link: "/report-nilai-kompetensi",
        parentId: 1,
      },
      {
        id: 11,
        label: "Report Nilai Jabatan",
        link: "/report-nilai-jabatan",
        parentId: 1,
      },
      {
        id: 12,
        label: "Report Hasil",
        link: "/report-hasil",
        parentId: 1,
      },
      {
        id: 32,
        label: "Report Pembinaan Grade",
        link: "/report-pembinaan-grade",
        parentId: 15,
      },
      {
        id: 29,
        label: "Report Analisa Soal",
        link: "/report-analisa-soal",
        parentId: 1,
      },
      {
        id: 26,
        label: "Report Success Profile",
        link: "/report-success-profile",
        parentId: 1,
      },
      {
        id: 28,
        label: "Report Tools Asesmen",
        link: "/report-tools-asesmen",
        parentId: 1,
      },
      {
        id: 43,
        label: "Report Survei Peserta",
        link: "/report-survei-peserta",
        parentId: 1,
      },
      {
        id: 55,
        label: "Report Proctor Peserta",
        link: "/report-proctor-peserta",
        parentId: 1,
      },
    ],
  },
  {
    id: 13,
    label: "Log Peserta",
    link: "/log-peserta",
    parentId: 1,
  },
  {
    id: 14,
    label: "File Manager",
    link: "/file-manager",
    parentId: 1,
  },
  // {
  //   id: 31,
  //   label: "Informasi Ujian Demo",
  //   link: "/info-ujian-demo",
  //   parentId: 1,
  // },
  {
    id: 14,
    label: "Informasi Ujian",
    link: "/info-ujian",
    parentId: 1,
  },
  {
    id: 19,
    label: "Manajemen Hak Akses",
    subItems: [
      {
        id: 20,
        label: "Role User",
        link: "/master/role",
        parentId: 19,
      },
      {
        id: 21,
        label: "User",
        link: "/master/user",
        parentId: 19,
      },
    ],
  },
  {
    id: 33,
    label: "Audit Log",
    subItems: [
      {
        id: 34,
        label: "Log Aktivitas",
        link: "/log-activity",
        parentId: 33,
      },
      {
        id: 35,
        label: "Log Aksi",
        link: "/log-action",
        parentId: 33,
      },
      {
        id: 36,
        label: "Log Aktivitas Peserta",
        link: "/log-activity-peserta",
        parentId: 33,
      },
    ],
  },
  {
    id: 900,
    label: "Master Dashboard",
    subItems: [
      {
        id: 901,
        label: "Config Dashboard",
        link: "/master/dashboard",
        parentId: 900,
      },
    ],
  },
];
